import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const fetchCeaProfileDownloadFiles = async ([payload, controller]) => {
  const url = URLS.DRM_CEA_PROFILE_DOWNLOAD_FILES;

  const response = await axios.post(url, payload, {
    signal: controller.signal,
  });

  if (response.status >= 400) {
    throw new Error(response.data?.message);
  }

  return response;
};
